<template>
    <div>
        <vue3-confirm-dialog></vue3-confirm-dialog>
        <div v-if="is_bootstrapping" class="trial_initial_loader" role="status" aria-live="polite">
            <span class="trial_initial_loader_spinner" aria-hidden="true"></span>
            <p>Loading...</p>
        </div>
        <template v-else>
            <div class="container">
                <div v-if="!is_success_mode" class="trial_wrapper">
                    <div class="trial_content_wrap">
                        <!-- Native SDK Container -->
                        <div class="trial_card selected">
                            <div class="form_header">
                                <div class="text_container">
                                    <p class="form_title">barKoder SDK</p>
                                    <p class="form_description">For Android and iOS mobile applications.</p>
                                </div>
                                <div class="svg_wrapper">
                                    <svg width="40" height="34" viewBox="0 0 40 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M32.9859 20.5824C32.2276 20.5824 31.5714 21.0494 31.3089 21.7646C30.8277 23.0636 30.1569 24.2896 29.3111 25.3259C27.0508 27.9092 23.5218 29.5731 20.0366 29.5731C16.5514 29.5731 13.0807 28.026 10.8204 25.3259C9.93089 24.2896 9.26009 23.0782 8.77886 21.7792C8.51638 21.064 7.86016 20.5824 7.10187 20.5824H4.66658C4.06869 20.5824 3.64579 21.1516 3.8062 21.7208C4.43325 24.0853 5.52695 26.2308 7.14561 28.1573C10.2954 31.9521 14.8744 33.9516 20.022 33.9516C25.1697 33.9516 29.734 31.9521 32.8984 28.1573C34.4879 26.2308 35.5962 24.0999 36.2087 21.7354C36.3545 21.1662 35.9462 20.597 35.3483 20.597H32.9713L32.9859 20.5824ZM16.5659 4.8925C17.5284 4.62978 18.7533 4.44005 19.9783 4.44005C21.2032 4.44005 22.4865 4.62978 23.5218 4.8925C27.3279 5.88498 30.0257 8.65807 31.2943 12.2339C31.5422 12.9491 32.213 13.4307 32.9713 13.4307H35.3045C35.9024 13.4307 36.3253 12.8615 36.1649 12.2777C34.6483 6.68772 30.6381 2.29454 24.7905 0.630685C23.1135 0.178232 21.5678 0.046875 20.022 0.046875C18.4763 0.046875 16.6826 0.178232 15.1369 0.630685C9.24551 2.29454 5.36654 6.71691 3.84995 12.2777C3.68954 12.8469 4.11244 13.4307 4.71033 13.4307H7.11645C7.87475 13.4307 8.54555 12.9491 8.79345 12.2339C10.0621 8.65807 12.7453 5.89957 16.5368 4.8925H16.5659Z" fill="black"/>
                                        <path d="M40 17.0062C40 17.9986 39.198 18.8014 38.2064 18.8014H1.79366C0.802046 18.8014 0 17.9986 0 17.0062C0 16.0137 0.802046 15.2109 1.79366 15.2109H38.2064C39.198 15.2109 40 16.0137 40 17.0062Z" fill="#FF3355"/>
                                    </svg>
                                </div>
                            </div>
                            <!-- Native SDK Form -->
                            <div class="trial_form_container visible">
                                
                                <form class="no_validate">
                                    <div class="input-line-wrapper">
                                        <div class="input-line-wrapper">
                                            <label for="app_name_native">App ID <span style="color:red;">*</span></label>
                                            <input type="text" id="app_name_native" name="app_name" v-model="state.app_name" class="input-line" :class="{ error: v$.app_name.$error }" placeholder="com.example.myprojectapp" required />
                                            <div v-if="v$.app_name.$error" class="input_description error">{{ v$.app_name.$errors[0].$message }}</div>
                                            <p class="input_description">
                                                Please enter your app identifier (iOS: "bundle identifier" / Android: "application ID"). Your license will be bound to this identifier.
                                            </p>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        
                        <div class="trial_card selected">
                            <div class="form_header">
                                <div class="text_container">
                                    <p class="form_title">barKoder WASM SDK</p>
                                    <p class="form_description">For all browser-based applications, including PWAs.</p>
                                </div>
                                <div class="svg_wrapper">
                                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3414 2H8C4.68629 2 2 4.68629 2 8V32C2 35.3137 4.68629 38 8 38H32C35.3137 38 38 35.3137 38 32V8C38 4.68629 35.3137 2 32 2H25.6586C24.8349 4.33038 22.6124 6 20 6C17.3876 6 15.1651 4.33038 14.3414 2ZM8 0C3.58172 0 0 3.58172 0 8V32C0 36.4183 3.58172 40 8 40H32C36.4183 40 40 36.4183 40 32V8C40 3.58172 36.4183 0 32 0H24C24 2.20914 22.2091 4 20 4C17.7909 4 16 2.20914 16 0H8Z" fill="#E52E4C"/>
                                        <path d="M26.4929 22.3005C26.1138 22.3005 25.7856 22.5348 25.6544 22.8935C25.4138 23.5451 25.0784 24.16 24.6555 24.6798C23.5254 25.9756 21.7609 26.8102 20.0182 26.8102C18.2756 26.8102 16.5403 26.0342 15.4102 24.6798C14.9654 24.16 14.63 23.5524 14.3894 22.9008C14.2581 22.5421 13.93 22.3005 13.5509 22.3005H12.3332C12.0343 22.3005 11.8228 22.586 11.903 22.8715C12.2166 24.0575 12.7634 25.1337 13.5727 26.1C15.1477 28.0035 17.4371 29.0064 20.011 29.0064C22.5848 29.0064 24.8669 28.0035 26.4492 26.1C27.2439 25.1337 27.798 24.0648 28.1043 22.8789C28.1772 22.5933 27.973 22.3078 27.6741 22.3078H26.4856L26.4929 22.3005ZM18.2829 14.4305C18.7641 14.2988 19.3766 14.2036 19.9891 14.2036C20.6015 14.2036 21.2432 14.2988 21.7609 14.4305C23.6639 14.9284 25.0128 16.3193 25.6471 18.113C25.7711 18.4717 26.1065 18.7133 26.4856 18.7133H27.6522C27.9512 18.7133 28.1626 18.4277 28.0824 18.1349C27.3241 15.331 25.319 13.1274 22.3952 12.2928C21.5567 12.0659 20.7838 12 20.011 12C19.2381 12 18.3412 12.0659 17.5684 12.2928C14.6227 13.1274 12.6832 15.3457 11.9249 18.1349C11.8447 18.4204 12.0562 18.7133 12.3551 18.7133H13.5582C13.9373 18.7133 14.2727 18.4717 14.3967 18.113C15.031 16.3193 16.3726 14.9357 18.2683 14.4305H18.2829Z" fill="#E52E4C"/>
                                        <path d="M30 20.5069C30 21.0047 29.599 21.4074 29.1032 21.4074H10.8968C10.401 21.4074 10 21.0047 10 20.5069C10 20.0091 10.401 19.6064 10.8968 19.6064H29.1032C29.599 19.6064 30 20.0091 30 20.5069Z" fill="#E52E4C"/>
                                    </svg>
                                </div>
                            </div>
                            <!-- WASM SDK Form -->
                            <div class="trial_form_container visible">
                                <form id="trialFormWasm" class="no_validate">
                                    <div class="input-line-wrapper">
                                        <div class="input-line-wrapper">
                                            <label for="domain">Domain <span style="color:red;">*</span></label>
                                            <input type="text" id="domain" name="domain" v-model="state.domain" class="input-line" :class="{ error: v$.domain.$error }" placeholder="example.com" required />
                                            <div v-if="v$.domain.$error" class="input_description error">{{ v$.domain.$errors[0].$message }}</div>
                                            <p class="input_description">Enter the domain where the SDK will be used. Your license will be tied to this domain.</p>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div class="email_container">
                        <div class="d-flex f-d-c gap8">
                            <div v-html="form_title"></div>
                            <div v-html="form_description"></div>
                        </div>
                        
                        <div class="register_like_fields trial_form_container visible">

                            <!-- Show login form if email exists -->
                            <template v-if="!logged_in && email_exists && show_login_form">
                                <div class="d-flex f-d-c gap24">
                                    <div class="d-flex gap48 f-wrap-w">
                                        <div class="flex-1-1-0">
                                            <div class="input-line-wrapper">
                                                <label for="email_native">Email <span v-if="checking_email">- checking email</span></label>
                                                <input type="email" id="email_native" name="email" v-model="state.email" class="input-line" :class="{ error: v$.email.$error }" placeholder="Your email address" :disabled="logged_in" />
                                                <div v-if="v$.email.$error" class="input_description error">{{ v$.email.$errors[0].$message }}</div>
                                                <div class="input_description error">This email is already registered. Please login to continue.</div>
                                            </div>
                                        </div>
                                        <div class="flex-1-1-0 input-line-wrapper">
                                            <label for="login_password">Password</label>
                                            <input type="password" id="login_password" name="login_password" v-model="state.login_password" class="input-line" placeholder="Enter your password" autocomplete="current-password" @keyup.enter="handleLogin" />
                                        </div>
                                    </div>
                                    <div class="d-flex gap16">
                                        <button @click="cancelLogin" class="button link outline" type="button">Use Different Email</button>
                                        <button @click="handleLogin" class="button link red mla-i arrow-right" type="button" :class="{ loader: form_submitting }" :disabled="form_submitting">Login <svg viewBox="0 0 20 20"><use :xlink:href="spriteHref('arrow_right')"></use></svg></button>
                                    </div>
                                    <p class="t-align-r">
                                        <a :href="home_url+'password-reset'" target="_blank">Forgot your password?</a>
                                    </p>
                                </div>
                            </template>
                            
                            <!-- Show registration fields if email doesn't exist -->
                            <template v-else-if="!logged_in && !email_exists && !show_login_form">
                                <div class="d-flex f-d-c gap24">
                                    <div class="d-flex gap48 f-wrap-w">
                                        <div class="flex-1-1-0 d-flex gap16 f-d-c">
                                            <div class="input-line-wrapper">
                                                <label for="email_native">Email <span v-if="checking_email">- checking email</span></label>
                                                <input type="email" id="email_native" name="email" v-model="state.email" class="input-line" :class="{ error: v$.email.$error }" placeholder="Your email address" :disabled="logged_in" />
                                                <div v-if="v$.email.$error" class="input_description error">{{ v$.email.$errors[0].$message }}</div>
                                            </div>
                                            <div class="input-line-wrapper">
                                                <label for="first_name">First Name</label>
                                                <input type="text" id="first_name" name="first_name" v-model="state.first_name" class="input-line" :class="{ error: v$.first_name?.$error }" placeholder="First Name" />
                                                <div v-if="v$.first_name.$error" class="input_description error">{{ v$.first_name.$errors[0].$message }}</div>
                                            </div>
                                            <div class="input-line-wrapper">
                                                <label for="last_name">Last Name</label>
                                                <input type="text" id="last_name" name="last_name" v-model="state.last_name" class="input-line" :class="{ error: v$.last_name?.$error }" placeholder="Last Name" />
                                                <div v-if="v$.last_name.$error" class="input_description error">{{ v$.last_name.$errors[0].$message }}</div>
                                            </div>
                                        </div>
                                        <div class="flex-1-1-0 d-flex gap16 f-d-c">
                                            <div class="input-line-wrapper">
                                                <label for="company">Company</label>
                                                <input type="text" id="company" name="company" v-model="state.company" class="input-line" :class="{ error: v$.company?.$error }" placeholder="Company" />
                                                <div v-if="v$.company.$error" class="input_description error">{{ v$.company.$errors[0].$message }}</div>
                                            </div>
                                            <div class="input-line-wrapper">
                                                <label for="country">Country</label>
                                                <select id="country" name="country" v-model="state.country" class="input-line" :class="{ error: v$.country?.$error }">
                                                    <option value="">Select Country</option>
                                                    <option v-for="(name, code) in countries" :key="code" :value="code">{{ name }}</option>
                                                </select>
                                                <div v-if="v$.country.$error" class="input_description error">{{ v$.country.$errors[0].$message }}</div>
                                            </div>
                                            <div class="input-line-wrapper">
                                                <label for="phone">Phone Number</label>
                                                <input type="text" id="phone" name="phone" v-model="state.phone" class="input-line" :class="{ error: v$.phone?.$error }" placeholder="Phone Number" />
                                                <div v-if="v$.phone.$error" class="input_description error">{{ v$.phone.$errors[0].$message }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex gap48 f-wrap-w">
                                        <div class="flex-1-1-0 input-line-wrapper">
                                            <label for="password">Password</label>
                                            <input type="password" id="password" name="password" v-model="state.password" class="input-line" :class="{ error: v$.password?.$error }" placeholder="Password" autocomplete="new-password" />
                                            <div class="password-validation">
                                                <div class="item" :class="{ valid: passwordHasLength, invalid: !passwordHasLength }">
                                                    Between 8 and 20 characters long
                                                </div>
                                                <div class="item" :class="{ valid: passwordHasUpper, invalid: !passwordHasUpper }">
                                                    One uppercase character
                                                </div>
                                                <div class="item" :class="{ valid: passwordHasLower, invalid: !passwordHasLower }">
                                                    One lowercase character
                                                </div>
                                                <div class="item" :class="{ valid: passwordHasDigitOrSpecial, invalid: !passwordHasDigitOrSpecial }">
                                                    One number, whitespace or special character
                                                </div>
                                            </div>
                                        </div>
                                        <div class="flex-1-1-0 input-line-wrapper">
                                            <label for="confirm_password">Confirm Password</label>
                                            <input type="password" id="confirm_password" name="confirm_password" v-model="state.confirm_password" class="input-line" :class="{ error: v$.confirm_password?.$error || passwordMismatch }" placeholder="Confirm Password" autocomplete="new-password" />
                                            <div v-if="confirmPasswordHasInput" class="password-validation confirm-password-validation">
                                                <div class="item" :class="{ valid: passwordsMatch, invalid: passwordMismatch }">
                                                    {{ passwordMismatch ? "Passwords do not match" : "Passwords match" }}
                                                </div>
                                            </div>
                                            <div v-if="v$.confirm_password.$error" class="input_description error">{{ v$.confirm_password.$errors[0].$message }}</div>
                                        </div>
                                    </div>
                                    <label class="checkbox_container" :class="{ error: v$.agreement.$error }">
                                        <input type="checkbox" class="terms_agreement custom_checkbox" name="agreement" v-model="state.agreement" />
                                        <span class="checkbox_label_text">
                                            By generating the Trial License Code and using the SDK, I accept the <a :href="home_url+'EULA'" target="_blank">Evaluation Agreement</a>
                                        </span>
                                    </label>
                                    <Transition name="fade">
                                        <div v-if="!can_create_more_licenses" class="input_description error">
                                            You have reached the maximum number of trial licenses.
                                        </div>
                                    </Transition>
                                    <div class="btn_container">
                                        <button @click.prevent="submitForm" class="button link red arrow-right" :class="{ loader: form_submitting }" type="submit" :disabled="!can_create_more_licenses">Submit <svg viewBox="0 0 20 20"><use :xlink:href="spriteHref('arrow_right')"></use></svg></button>
                                    </div>
                                </div>
                            </template>

                            <!-- Show only email form if logged in -->
                            <template v-else-if="logged_in && !show_login_form">
                                <div class="d-flex f-d-c gap24">
                                    <div class="d-flex f-d-c gap16">
                                        <div class="input-line-wrapper">
                                            <label for="email_native">Email</label>
                                            <input type="email" id="email_native" name="email" v-model="state.email" class="input-line" :class="{ error: v$.email.$error }" placeholder="Your email address" disabled />
                                        </div>
                                        <label v-if="can_create_more_licenses" class="checkbox_container" :class="{ error: v$.agreement.$error }">
                                            <input type="checkbox" class="terms_agreement custom_checkbox" name="agreement" v-model="state.agreement" />
                                            <span class="checkbox_label_text">
                                                By generating the Trial License Code and using the SDK, I accept the <a :href="home_url+'EULA'" target="_blank">Evaluation Agreement</a>
                                            </span>
                                        </label>
                                    </div>
                                    <Transition name="fade">
                                        <div v-if="!can_create_more_licenses" class="input_description error">
                                            You have reached the maximum number of trial licenses.
                                        </div>
                                    </Transition>
                                    <div class="d-flex gap16">
                                        <button @click="submitForm" class="button link red mla-i arrow-right" type="button" :class="{loader: form_submitting}" :disabled="!can_create_more_licenses">Submit <svg viewBox="0 0 20 20"><use :xlink:href="spriteHref('arrow_right')"></use></svg></button>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="trial_license_wrap" v-if="state.generated_license && !form_submitting">
                <div class="container">
                    <Transition name="fade">
                        <section class="container">
                            <header class="margin-bottom-40">
                                <label>SDK type</label>
                                <h2>Select (Native + Cross Platform) or Web</h2>
                            </header>
                            <!-- Generated License Section -->
                            <div class="trial_license_card">
                                <div>
                                    <h2 class="license-title">Your Trial License</h2>
                                    <p class="license-description" v-html="state.generated_license_text_line"></p>
                                </div>
                                <div class="licenseText">{{ state.generated_license_text }}</div>
                                <div class="btn_container">
                                    <button class="button link fill-red" @click="copyLicense(state.generated_license_text)">Copy License</button>
                                </div>
                                <div class="docs_container">
                                    <p class="docs_title">Documentation</p>
                                    <div class="framework_items v1 justify-left">
                                        <a :href="home_url+'docs/v1/ios'" target="_blank">
                                            <div class="logo">
                                                <svg viewBox="0 0 20 17.83"><use :xlink:href="spriteHref('ios_logo')"></use></svg>
                                            </div>
                                            <h3>iOS</h3>
                                        </a>
                                        <a :href="home_url+'docs/v1/android'" target="_blank">
                                            <div class="logo">
                                                <svg viewBox="0 0 20 17.83"><use :xlink:href="spriteHref('android_logo')"></use></svg>
                                            </div>
                                            <h3>Android</h3>
                                        </a>
                                        <a :href="home_url+'docs/v1/barkoder-web-sdk'" target="_blank">
                                            <div class="logo">
                                                <svg viewBox="0 0 20 17.83"><use :xlink:href="spriteHref('wasm_logo')"></use></svg>
                                            </div>
                                            <h3>WASM</h3>
                                        </a>
                                        <a :href="home_url+'docs/v1/linux-sdk-installation'" target="_blank">
                                            <div class="logo">
                                                <svg viewBox="0 0 20 17.83"><use :xlink:href="spriteHref('linux_logo')"></use></svg>
                                            </div>
                                            <h3>Linux</h3>
                                        </a>
                                        <a :href="home_url+'docs/v1/maui'" target="_blank">
                                            <div class="logo">
                                                <svg viewBox="0 0 20 17.83"><use :xlink:href="spriteHref('net_maui_logo')"></use></svg>
                                            </div>
                                            <h3>.NET Maui</h3>
                                        </a>
                                        <a :href="home_url+'docs/v1/flutter'" target="_blank">
                                            <div class="logo">
                                                <svg viewBox="0 0 48 48"><use :xlink:href="spriteHref('flutter_logo')"></use></svg>
                                            </div>
                                            <h3>Flutter</h3>
                                        </a>
                                        <a :href="home_url+'docs/v1/react-native'" target="_blank">
                                            <div class="logo">
                                                <svg viewBox="0 0 24 24"><use :xlink:href="spriteHref('react_logo')"></use></svg>
                                            </div>
                                            <h3>React Native</h3>
                                        </a>
                                        <a :href="home_url+'docs/v1/cordova'" target="_blank">
                                            <div class="logo">
                                                <svg viewBox="0 0 20 19.12"><use :xlink:href="spriteHref('cordova_logo')"></use></svg>
                                            </div>
                                            <h3>Cordova</h3>
                                        </a>
                                        <a :href="home_url+'docs/v1/capacitor'" target="_blank">
                                            <div class="logo">
                                                <svg viewBox="0 0 20 20"><use :xlink:href="spriteHref('capacitor_logo')"></use></svg>
                                            </div>
                                            <h3>Capacitor</h3>
                                        </a>
                                        <a :href="home_url+'docs/v1/nativescript'" target="_blank">
                                            <div class="logo">
                                                <svg width="138" viewBox="0 0 137.2 136.3"><use :xlink:href="spriteHref('nativescript_logo')"></use></svg>
                                            </div>
                                            <h3>NativeScript</h3>
                                        </a>
                                        <a :href="home_url+'docs/v1/python'" target="_blank">
                                            <div class="logo">
                                                <svg width="138" viewBox="0 0 137.2 136.3"><use :xlink:href="spriteHref('python_logo')"></use></svg>
                                            </div>
                                            <h3>Python</h3>
                                        </a>
                                        <a :href="home_url+'docs/v1/c-sdk-installation'" target="_blank">
                                            <div class="logo">
                                                <svg width="138" viewBox="0 0 137.2 136.3"><use :xlink:href="spriteHref('c_sharp_logo')"></use></svg>
                                            </div>
                                            <h3>C#</h3>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </Transition>
                </div>
            </div>
            <!-- Repository Component - Only show if user is logged in -->
            <Repository 
                v-if="logged_in"
                :account-activated="account_activated"
            />
            <div class="trial_license_wrap" v-if="evaluation_licenses.length">
                <div class="container">
                    <header>
                        <label>License(s)</label>
                        <h2>Your Trial License(s)</h2>
                    </header>
                    <div class="trial_license_list">
                        <template v-for="(license,gIndex) in evaluation_licenses">
                            <div class="trial_license_card" v-if="license.license" :key="'gIndex_'+gIndex" >
            
                                <div class="item" v-if="license.data.exp">
                                    <span class="t">Expires on</span>
                                    <div class="text">{{ license.data.exp }}</div>
                                </div>
            
                                <div class="item" v-if="license.data.kv">
                                    <span class="t">Key Version</span>
                                    <div class="text">{{ license.data.kv }}</div>
                                </div>
                            
                                <div class="item" v-if="license.data.mver">
                                    <span class="t">Min Version</span>
                                    <div class="text">{{ license.data.mver }}</div>
                                </div>
                            
                                <template v-if="this.isArray(license.data.apn) && this.arrLength(license.data.apn) > 0">
                                    <div v-for="apns in license.data.apn" class="item">
                                        <span class="t">App name / Platform</span>
                                        <template v-if="isObject(apns)">
                                            <div class="text flex breakWord">
                                                {{ displayAppNames(apns.apn) }} / {{ bitmaskToPlatform(apns.pl,true) }}
                                            </div>
                                        </template>
                                        <div v-else class="text no-wrap">{{ license.data.apn.join(', ') }}</div>
                                    </div>    
                                </template>
                                    
                                <div class="item" v-if="license.data.platforms">
                                    <span class="t">Platform(s)</span>
                                    <div class="text no-wrap">{{ printPlatforms(license) }}</div>
                                </div>
            
                                <div class="item" v-if="license.data.symbologies">
                                    <span class="t">Barcode Types</span>
                                    <div class="text">{{ printSymbologies(license) }}</div>
                                </div>
            
                                <div class="item no-bg">
                                    <span class="t">License key</span>
                                    <div class="license_container">
                                        <div class="licenseText">{{ license.license }}</div>
                                        <button class="copy_license_button" @click="copyLicense(license.license)">
                                            <svg viewBox="0 0 24 24"><use :xlink:href="spriteHref('copy')"></use></svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </template>

    </div>
</template>

<script>
import { ref, reactive, computed } from "vue";
import Repository from './components/Repository.vue';
import useValidate from "@vuelidate/core";
import {
    required,
    sameAs,
    helpers,
    requiredIf,
    email as emailValidator,
    maxLength,
} from "@vuelidate/validators";
import { HOME_URL, ENV, WEB_USERNAME, WEB_PASS, ALL_SYMOBOLIES, LIST_PLATFORM, BITMASK_TO_PLATFORM } from "./constants/envrionment";

import { useReCaptcha } from 'vue-recaptcha-v3'

export default {
    components: {
        Repository
    },
    props: ["logged_in", "selected_barcodes", "selected_technologies"],
    setup(props) {
        const state = reactive({
            email: "",
            first_name: "",
            last_name: "",
            company: "",
            country: "",
            phone: "",
            password: "",
            confirm_password: "",
            app_name: "",
            domain: "",
            agreement: false,
            recaptcha_token: "",
            generated_license: false,
            generated_license_text: "",
            generated_license_expires_date: "",
            generated_license_text_line: "",
            login_password: "",
            unique_id: "",
        });
        
        const loggedIn = ref(false);
        const emailExists = ref(false);
        const checkingEmail = ref(false);
        const showLoginForm = ref(false);
        const successMode = ref(false);
        const successClaim = ref('');
        const successClaimError = ref('');
        
        const countries = ref(typeof support_countries !== 'undefined' ? support_countries : {});

        const rules = computed(() => {
            let account_rules = {},
            required_rules = {
                first_name: {
                    requiredIf: helpers.withMessage("First Name is required!", requiredIf(() => !loggedIn.value)),
                    maxLength: helpers.withMessage("First Name must be at most 20 characters!", maxLength(20)),
                },
                last_name: {
                    requiredIf: helpers.withMessage("Last Name is required!", requiredIf(() => !loggedIn.value)),
                    maxLength: helpers.withMessage("Last Name must be at most 20 characters!", maxLength(20)),
                },
                company: {
                    requiredIf: helpers.withMessage("Company is required!", requiredIf(() => !loggedIn.value)),
                    maxLength: helpers.withMessage("Company must be at most 100 characters!", maxLength(100)),
                },
                country: {
                    requiredIf: helpers.withMessage("Country is required!", requiredIf(() => !loggedIn.value)),
                    validCountry: helpers.withMessage("Invalid country selected!", (val) => loggedIn.value || (!!val && Object.prototype.hasOwnProperty.call(countries.value, val)))
                },
                phone: {
                    requiredIf: helpers.withMessage("Phone Number is required!", requiredIf(() => !loggedIn.value)),
                    validDigits: helpers.withMessage("Phone Number is not valid!", (val) => {
                        if (loggedIn.value) return true;
                        if (!val) return false;
                        const digits = (val + '').replace(/\D/g, '');
                        return digits.length >= 9;
                    }),
                    validFormat: helpers.withMessage(
                        "Phone Number is not valid!",
                        (val) => {
                            if (loggedIn.value) return true;
                            if (!val) return true;
                            const phoneRegex = /^(?:\+?\d{1,3})?(?:[ \-\.\/]?\(?\d{1,4}\)?)(?:[ \-\.\/]?\d{1,4}){2,4}$/;
                            return phoneRegex.test(String(val));
                        }
                    ),
                },
                app_name: {
                    requiredIf: helpers.withMessage("At least one of App ID or Domain is required!", requiredIf(() => !state.domain)),
                },
                domain: {
                    requiredIf: helpers.withMessage("At least one of App ID or Domain is required!", requiredIf(() => !state.app_name)),
                },
                email: {
                    requiredIf: helpers.withMessage("The Email address field is required!", requiredIf(() => !loggedIn.value)),
                    email: helpers.withMessage("Enter a valid email address!", emailValidator),
                },
                password: {
                    requiredIf: helpers.withMessage("Password is required!", requiredIf(() => !loggedIn.value)),
                    length: helpers.withMessage(
                        "Password must be between 8 and 20 characters!",
                        (val) => {
                            if (!val) return true;
                            const s = String(val);
                            return s.length >= 8 && s.length <= 20;
                        }
                    ),
                    upper: helpers.withMessage(
                        "Include at least one uppercase character!",
                        (val) => {
                            if (!val) return true;
                            return /[A-Z]/.test(String(val));
                        }
                    ),
                    lower: helpers.withMessage(
                        "Include at least one lowercase character!",
                        (val) => {
                            if (!val) return true;
                            return /[a-z]/.test(String(val));
                        }
                    ),
                    digitOrSpec: helpers.withMessage(
                        "Include at least one number, whitespace or special character!",
                        (val) => {
                            if (!val) return true;
                            return /(\d|\W|\s)/.test(String(val));
                        }
                    ),
                },
                confirm_password: {
                    requiredIf: helpers.withMessage("Please confirm your password!", requiredIf(() => !loggedIn.value)),
                    matchesPassword: helpers.withMessage(
                        "Passwords don't match!",
                        (val) => {
                            // If not required here, skip match check
                            if (!val && !(!loggedIn.value)) return true;
                            return String(val || '') === String(state.password || '');
                        }
                    ),
                },
                agreement: {
                    sameAs: helpers.withMessage("You must accept the Evaluation Agreement to continue.", sameAs(true)),
                },
                recaptcha_token: {
                    required: helpers.withMessage("reCAPTCHA validation failed!", required),
                },
            };
            
            return {
                ...required_rules,
                ...account_rules,
            };
        });
        
        const v$ = useValidate(rules, state);
        
        return {
            home_url: HOME_URL,
            state,
            countries: countries,
            all_symbologies: ALL_SYMOBOLIES,
            list_platform: LIST_PLATFORM,
            bitmask_to_platform: BITMASK_TO_PLATFORM,
            evaluation_licenses: ref([]),
            logged_in: loggedIn,
            email_exists: emailExists,
            checking_email: checkingEmail,
            show_login_form: showLoginForm,
            is_success_mode: successMode,
            success_claim: successClaim,
            success_claim_error: successClaimError,
            is_bootstrapping: ref(true),
            can_create_more_licenses: ref(true),
            form_title: ref("<h3>We need your email to tie the trial license to you.</h3>"),
            form_description: ref("<p>This will not register an account within a system but it will enable you to contact us with further details about your license.</p>"),
            v$,
            form_submitting: ref(false),
            recaptcha: useReCaptcha(),
            is_admin: ref(false),
            is_client: ref(false),
            account_activated: ref(false)
        };
    },
    computed: {
        selected_country() {
            return "";
        },
        passwordHasLength() {
            return !!this.state.password && this.state.password.length >= 8 && this.state.password.length <= 20;
        },
        passwordHasUpper() {
            return /[A-Z]/.test(this.state.password || '');
        },
        passwordHasLower() {
            return /[a-z]/.test(this.state.password || '');
        },
        passwordHasDigitOrSpecial() {
            return /(\d|\W|\s)/.test(this.state.password || '');
        },
        confirmPasswordHasInput() {
            return !!this.state.confirm_password;
        },
        passwordsMatch() {
            return this.confirmPasswordHasInput && !!this.state.password && this.state.password === this.state.confirm_password;
        },
        passwordMismatch() {
            return this.confirmPasswordHasInput && !!this.state.password && this.state.password !== this.state.confirm_password;
        },
    },
    watch: {
        'state.email': function(newEmail, oldEmail) {
            if (!this.is_success_mode && !this.logged_in && newEmail && newEmail.includes('@') && newEmail.includes('.')) {
                this.checkEmailExists(newEmail);
            } else {
                this.email_exists = false;
                this.show_login_form = false;
            }
        }
    },
    methods: {
        syncTrialCardHeaderHeights() {
            const wrapper = this.$el ? this.$el.querySelector('.trial_content_wrap') : null;
            if (!wrapper) {
                return;
            }

            const headers = Array.from(wrapper.querySelectorAll('.trial_card .form_header'));
            if (!headers.length) {
                wrapper.style.removeProperty('--trial-form-header-height');
                return;
            }

            if (window.matchMedia('(max-width: 767px)').matches) {
                wrapper.style.removeProperty('--trial-form-header-height');
                return;
            }

            const maxHeight = Math.max(...headers.map((header) => header.getBoundingClientRect().height));
            wrapper.style.setProperty('--trial-form-header-height', Math.ceil(maxHeight) + 'px');
        },
        setupTrialCardHeaderHeightSync() {
            this.teardownTrialCardHeaderHeightSync();

            const wrapper = this.$el ? this.$el.querySelector('.trial_content_wrap') : null;
            if (!wrapper) {
                return;
            }

            const scheduleSync = () => {
                if (this._trialCardHeaderRafId) {
                    cancelAnimationFrame(this._trialCardHeaderRafId);
                }

                this._trialCardHeaderRafId = requestAnimationFrame(() => {
                    this.syncTrialCardHeaderHeights();
                });
            };

            this._trialCardHeaderResizeHandler = scheduleSync;
            window.addEventListener('resize', this._trialCardHeaderResizeHandler);

            if (typeof ResizeObserver !== 'undefined') {
                this._trialCardHeaderResizeObserver = new ResizeObserver(scheduleSync);
                const headers = wrapper.querySelectorAll('.trial_card .form_header');
                headers.forEach((header) => this._trialCardHeaderResizeObserver.observe(header));
            }

            scheduleSync();
        },
        teardownTrialCardHeaderHeightSync() {
            if (this._trialCardHeaderResizeHandler) {
                window.removeEventListener('resize', this._trialCardHeaderResizeHandler);
                this._trialCardHeaderResizeHandler = null;
            }

            if (this._trialCardHeaderResizeObserver) {
                this._trialCardHeaderResizeObserver.disconnect();
                this._trialCardHeaderResizeObserver = null;
            }

            if (this._trialCardHeaderRafId) {
                cancelAnimationFrame(this._trialCardHeaderRafId);
                this._trialCardHeaderRafId = null;
            }
        },
        generateRecaptchaToken () {
            // (optional) Wait until recaptcha has been loaded.
            const { executeRecaptcha, recaptchaLoaded } = this.recaptcha;

            return recaptchaLoaded().then(() => {
                return executeRecaptcha('generate');
            }).then((recaptcha_token) => {
                this.state.recaptcha_token = encodeURIComponent(recaptcha_token);
                return recaptcha_token;
            });
        },
        async submitForm() {
            let self = this;
            
            if (!this.can_create_more_licenses) {
                $.append_notification("error", "You have reached the maximum number of trial licenses.");
                return;
            }

            await this.generateRecaptchaToken()

            this.v$.$validate();
            
            if (this.v$.$error) {
                let errors = [];
                
                for (let i = 0; i < this.v$.$errors.length; i++) {
                    let o = this.v$.$errors[i];
                    
                    errors.push("<p>" + o.$message + "</p>");
                }
                
                errors = errors.join("");
                
                // $.append_notification("error", errors);
                $.append_notification("error", 'Please complete all required fields before submitting the form.');

                // Scroll to the first invalid input
                this.$nextTick(() => {
                    const firstError = document.querySelector('.input-line.error');
                    if (firstError) {
                        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                });
            }
            else {

                self.form_submitting = true;
                
                try {
                    let post_params = {
                        recaptcha_token: self.state.recaptcha_token,
                        app_name: self.state.app_name,
                        domain: self.state.domain,
                        unique_id: self.state.unique_id,
                    };
                    
                    if (!self.logged_in) {
                        post_params.email = self.state.email;
                        post_params.first_name = self.state.first_name;
                        post_params.last_name = self.state.last_name;
                        post_params.company = self.state.company;
                        post_params.country = self.state.country;
                        post_params.phone = self.state.phone;
                        post_params.password = self.state.password;
                        post_params.confirm_password = self.state.confirm_password;
                    }
                    
                    // POST request using fetch with error handling
                    var requestOptions = {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(post_params),
                    };
                    
                    if (ENV == "dev") {
                        requestOptions["headers"]["authorization"] = "Basic " + btoa(WEB_USERNAME + ":" + WEB_PASS);
                    }
                    
                    fetch(self.home_url + "spr/free_trial/new", requestOptions)
                    .then(async (response) => {

                        const data = await response.json();
                        
                        self.form_submitting = false;

                        if (data.status) {

                            if (data.redirect_url) {
                                window.location.href = data.redirect_url;
                                return;
                            }

                            $.append_notification('success', 'Trial created successfully!');

                            self.logged_in = true;
                            self.state.generated_license              = true;
                            self.state.generated_license_text         = data.license;
                            self.state.generated_license_text_line    = data.text_line;

                            // Empty the form fields after successful license generation
                            self.state.app_name = "";
                            self.state.domain = "";
                            if (!self.logged_in) {
                                self.state.email = "";
                                self.state.first_name = "";
                                self.state.last_name = "";
                                self.state.company = "";
                                self.state.country = "";
                                self.state.phone = "";
                                self.state.password = "";
                                self.state.confirm_password = "";
                                self.state.agreement = false;
                            }

                            // Scroll to the generated license card after a short delay to ensure DOM update
                            self.$nextTick(() => {
                                setTimeout(() => {
                                    const licenseCard = document.querySelector('.trial_license_card');
                                    if (licenseCard) {
                                        licenseCard.scrollIntoView({ 
                                            behavior: 'smooth', 
                                            block: 'start' 
                                        });
                                    }
                                }, 100);
                            });
                        } else {
                            self.state.generated_license = false;
                            $.append_notification('error', data.message);
                        }
                    })
                    .catch((error) => {
                        self.errorMessage = error;
                        console.error("There was an error!", error);
                    });
                } catch (err) {
                    console.log(err);
                }
            }
        },
        isString (value) {
            return typeof value === 'string' || value instanceof String;
        },
        isArray (value) {
            return value && typeof value === 'object' && value.constructor === Array;
        },
        arrLength(arr){
            return typeof arr != 'undefined' && this.isArray(arr) ? arr.length > 0 : 0
        },
        isObject (value) {
            return value && typeof value === 'object' && value.constructor === Object;
        },
        bitmaskToPlatform: function(pl,showPlKye){

            if(typeof this.bitmask_to_platform[pl] != 'undefined'){
                
                let p = this.bitmask_to_platform[pl]

                if(typeof showPlKye != 'undefined'){
                    return p
                }

                if(typeof this.list_platform[p] != 'undefined'){
                    return this.list_platform[p];
                }
                else{
                    return p;
                }
                
            }
            else
                return ''
        },
        displayAppNames(app_names){

            if(this.isString(app_names)){
                return app_names;
            }
            else if(this.isArray(app_names)){
                return app_names.join(', ')
            }
            else{
                return app_names
            }

        },
        printPlatforms: function(license){

            let self = this,
                platforms = [];

            if(this.isArray(license.data.platforms)){
                license.data.platforms.forEach(function(pl){
                    if(typeof self.list_platform[pl] != 'undefined'){
                        platforms.push(self.list_platform[pl]);
                    }
                    else
                        platforms.push(pl);
                })
            }

            return platforms.join(', ')

        },
        printSymbologies: function(license){

            let self = this,
                symbologies = [];

            if(this.isArray(license.data.symbologies)){
                license.data.symbologies.forEach(function(sym){
                    if(typeof self.all_symbologies[sym] != 'undefined'){
                        symbologies.push(self.all_symbologies[sym]);
                    }
                    else
                        symbologies.push(sym);
                })
            }

            return symbologies.join(', ')

        },
        copyLicense(license) {
            navigator.clipboard.writeText(license);
            $.append_notification('success', 'License copied to clipboard!');
        },
        checkEmailExists(email) {
            let self = this;
            
            // Debounce the email check
            clearTimeout(self.emailCheckTimeout);
            
            self.emailCheckTimeout = setTimeout(() => {
                self.checking_email = true;
                
                const formData = new FormData();
                formData.append('email', email);
                
                fetch(self.home_url + "support/ajax/register_email_check", {
                    method: "POST",
                    body: formData
                })
                .then(response => response.json())
                .then(result => {

                    setTimeout(() => {
                        self.checking_email = false;
                    }, 300);

                    
                    // The existing endpoint returns status: false if email exists
                    if (result.status === false) {
                        self.email_exists = true;
                        self.show_login_form = true;
                    } else {
                        self.email_exists = false;
                        self.show_login_form = false;
                    }
                })
                .catch(error => {
                    setTimeout(() => {
                        self.checking_email = false;
                    }, 300);
                });
            }, 500);
        },
        async handleLogin() {
            let self = this;
            
            if (!self.state.email || !self.state.login_password) {
                $.append_notification("error", "Please enter your password to login.");
                return;
            }
            
            // Generate unique_id if not already set
            if (!self.state.unique_id) {
                self.generateUniqueId();
            }
            
            self.form_submitting = true;
            
            await this.generateRecaptchaToken();
            
            $.post(self.home_url + 'auth/ajax/login', {
                email: self.state.email,
                password: self.state.login_password,
                unique_id: self.state.unique_id,
                recaptcha_token: self.state.recaptcha_token
            }, function(result) {
                
                self.generateRecaptchaToken();
                
                if (result.status) {
                    if (result.valid) {
                        $.append_notification('success', 'Login successful!');
                        
                        // Reset login form
                        self.state.login_password = '';
                        self.email_exists = false;
                        self.show_login_form = false;
                        self.form_submitting = false;
                        
                        // Fetch user data to show licenses
                        self.fetchUserData();
                    } else {
                        // 2FA required - not handling this in trial form for now
                        self.form_submitting = false;
                        $.append_notification('error', 'Two-factor authentication is required. Please use the login page.');
                    }
                } else {
                    self.form_submitting = false;
                    $.append_notification('error', result.message || 'Login failed. Please check your credentials.');
                }
            });
        },
        generateUniqueId() {
            let self = this;
            
            if (typeof Fingerprint2 !== 'undefined') {
                Fingerprint2.get(function(components) {
                    const values = components.map(function(component) { return component.value });
                    const murmur = Fingerprint2.x64hash128(values.join(''), 31);
                    self.state.unique_id = murmur;
                });
            } else {
                // Asynchronously load Fingerprint2 if not loaded
                var script = document.createElement('script');
                script.src = 'https://cdnjs.cloudflare.com/ajax/libs/fingerprintjs2/2.1.0/fingerprint2.min.js';
                script.async = true;
                script.onload = function() {
                    if (typeof Fingerprint2 !== 'undefined') {
                        Fingerprint2.get(function(components) {
                            const values = components.map(function(component) { return component.value });
                            const murmur = Fingerprint2.x64hash128(values.join(''), 31);
                            self.state.unique_id = murmur;
                        });
                    } else {
                        // Fallback if still not loaded
                        self.state.unique_id = 'fallback_' + Date.now() + '_' + Math.random();
                    }
                };
                script.onerror = function() {
                    // Fallback if script fails to load
                    self.state.unique_id = 'fallback_' + Date.now() + '_' + Math.random();
                };
                document.head.appendChild(script);
            }
        },
        cancelLogin() {
            // Reset login form state
            this.state.email = '';
            this.state.login_password = '';
            this.email_exists = false;
            this.show_login_form = false;
            this.checking_email = false;
        },
        fetchUserData() {

            let self = this;
            
            return fetch(this.home_url + "spr/ajax/free_trial_page_fetch_evaluation_licenses")
            .then(response => response.json())
            .then(result => {

                if(result.status) {
                    self.logged_in = true;
                    self.state.email = result.email;
                    self.evaluation_licenses = result.licenses;
                    self.can_create_more_licenses = result.can_create_more_licenses;
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
        },
        fetchSuccessClaimData() {
            let self = this;

            if (!self.success_claim) {
                return Promise.resolve();
            }

            return fetch(this.home_url + "spr/free_trial/success_data/" + encodeURIComponent(self.success_claim))
            .then(response => response.json())
            .then(result => {
                if (result.status) {
                    const claim = result.claim || {};

                    self.state.generated_license = true;
                    self.state.generated_license_text = claim.license || '';
                    self.state.generated_license_text_line = claim.text_line || '';

                    if (!self.state.email && claim.email) {
                        self.state.email = claim.email;
                    }
                }
                else {
                    self.success_claim_error = result.message || 'Unable to load generated trial details.';
                    $.append_notification('error', self.success_claim_error);
                }
            })
            .catch(() => {
                self.success_claim_error = 'Unable to load generated trial details.';
                $.append_notification('error', self.success_claim_error);
            });
        },
    },
    mounted: async function () {

        const initialRequests = [];

        const params = new URLSearchParams(window.location.search);
        const claimToken = params.get('claim');

        if (claimToken) {
            this.is_success_mode = true;
            this.success_claim = claimToken;
            initialRequests.push(this.fetchSuccessClaimData());
        }

		initialRequests.push(this.fetchUserData());

        if (!this.is_success_mode) {
            this.generateUniqueId();
        }


        // Fetch title and description from divs using vanilla JS
        if (!this.is_success_mode) {
        	var titleDiv = document.getElementById('trialFormTile');
        	if (titleDiv) {
        		this.form_title = titleDiv.innerHTML;
        	}
        	var descDiv = document.getElementById('trialFormDesc');
        	if (descDiv) {
        		this.form_description = descDiv.innerHTML;
        	}
        }

        await Promise.allSettled(initialRequests);
        this.is_bootstrapping = false;

        this.$nextTick(() => {
            this.setupTrialCardHeaderHeightSync();
        });
    },
    beforeUnmount() {
        this.teardownTrialCardHeaderHeightSync();
    }
};
</script>
